<template>
  <BgImageLayout title="FTE">
    <AgGridWrapper
      v-if="tableData"
      ref="agGrid"
      handle-update-on-parent
      has-export-excel
      :options="gridOptions"
      class="full-height"
      @cell-updated="update"
      @export-to-excel="mixinExportToExcel($event, [], 'fte-fields')"
    >
      <template #header-actions-before>
        <q-btn :loading="creatingNewField" size="sm" class="self-center" color="tertiary" @click="openDialog">
          Create new fte field
        </q-btn>
      </template>
    </AgGridWrapper>

    <q-card v-else class="loading">
      <q-card-section>
        <q-spinner color="primary" size="2rem" />
      </q-card-section>
    </q-card>
  </BgImageLayout>
</template>

<script>
import { exportToExcel } from '@/mixins/export-to-excel'
import * as apiTo from './api'
import { gridOptions } from './gridOptions'
// Components
import AgGridWrapper from '@/components/ag-grid-helpers/AgGridWrapper'
import ConfirmationDialog from '@/reusable/ConfirmationDialog/ConfirmationDialog'
import CreateFieldDialog from './components/CreateFieldDialog'

export default {
  components: {
    AgGridWrapper
  },

  mixins: [gridOptions, exportToExcel],

  data: () => ({
    tableData: null,
    creatingNewField: false
  }),

  created() {
    apiTo.getTableData().then(({ data }) => (this.tableData = data.result))
  },

  methods: {
    openDialog() {
      this.$q
        .dialog({
          component: CreateFieldDialog,
          title: 'Create FTE field'
        })
        .onOk(field => {
          this.creatingNewField = true
          apiTo
            .createNewField({ name: field })
            .then(({ data }) => {
              this.tableData.fields.push(data.result)
            })
            .finally(() => (this.creatingNewField = false))
        })
    },

    update({ newValue, oldValue, colDef: { field }, data: { id } }) {
      if (Number(newValue) === Number(oldValue)) return

      apiTo
        .updateField(id, { [field]: newValue })
        .then(({ data }) => {
          const index = this.tableData.fields.findIndex(f => f.id === id)
          if (~index) this.tableData.fields.splice(index, 1, data.result)
        })
        .catch(() => {
          this.$refs.agGrid.updateRowNode(
            id,
            this.tableData.fields.find(f => f.id === id)
          )
        })
    },

    async delete({ data: { id } }) {
      const { data } = await apiTo.getDeleteConfirmation(id)
      this.$q
        .dialog({
          component: ConfirmationDialog,
          title: 'Confirm',
          messages: data.messages.default
        })
        .onOk(() => {
          apiTo.deleteField(id).then(() => {
            const index = this.tableData.fields.findIndex(f => f.id === id)
            if (~index) this.tableData.fields.splice(index, 1)
          })
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

styledScrollFor('>>> .ag-body-viewport.ag-layout-normal');

>>> .ag-theme-material {
  height 100%
}

>>> .table-content {
  padding 0 40px
}

.ag-grid-wrapper-card {
  display grid
  grid-template-rows 50px 2px 1fr 35px
}

.top-bar-wrapper {
  height calc(100vh - 80px)
}

.loading {
  height calc(100vh - 80px)
  display flex
  justify-content center
  align-items center
}
</style>
